import React, { useEffect } from 'react';
const PIXEL_ID = '1562461915897564';
const SCRIPT_ID = 'meta-pixel-fbevents';
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js';
type FbqFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: FbqFunction;
  loaded: boolean;
  version: string;
};
declare global {
  interface Window {
    fbq?: FbqFunction;
    _fbq?: FbqFunction;
  }
}
function createFbqStub() {
  if (window.fbq) return;
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as FbqFunction;
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];
  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
}
function injectScript() {
  if (document.getElementById(SCRIPT_ID)) return;
  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.async = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);
}
export function MetaPixel() {
  useEffect(() => {
    createFbqStub();
    const interactionEvents: (keyof WindowEventMap)[] = ['pointerdown', 'scroll', 'keydown'];
    let idleHandle: number | undefined;
    let timeoutHandle: number | undefined;
    const cleanup = () => {
      interactionEvents.forEach(name => window.removeEventListener(name, load));
      window.removeEventListener('load', scheduleIdle);
      if (idleHandle !== undefined && 'cancelIdleCallback' in window) {
        window.cancelIdleCallback(idleHandle);
      }
      if (timeoutHandle !== undefined) window.clearTimeout(timeoutHandle);
    };
    function load() {
      cleanup();
      injectScript();
    }
    function scheduleIdle() {
      if ('requestIdleCallback' in window) {
        idleHandle = window.requestIdleCallback(load, {
          timeout: 2000
        });
      } else {
        timeoutHandle = window.setTimeout(load, 1500);
      }
    }
    interactionEvents.forEach(name => window.addEventListener(name, load, {
      once: true,
      passive: true
    }));
    if (document.readyState === 'complete') {
      scheduleIdle();
    } else {
      window.addEventListener('load', scheduleIdle, {
        once: true
      });
    }
    return cleanup;
  }, []);
  return <noscript data-id="element-127" data-mp="2rxpirp75db1a">
      <img height="1" width="1" style={{
      display: 'none'
    }} src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-128" data-mp="2rxfohpf2khps" />
    </noscript>;
}